import { createFileRoute } from "@tanstack/react-router";
import AdminSuppressionsPage from "@/admin/pages/suppressions";

export const Route = createFileRoute("/admin/suppressions")({
  component: AdminSuppressionsPage,
});
